import React from 'react';
import TableRow from './TableRow';
import './Table.css'

function Table({teams}) {
	return(<div className={'table flex flex-wrap mt0 ph3' + (teams.length > 0 ? ' mt5-ns pb5' : '')}>
		{/*<div className="table-header pt3 pb3 flex w-100">
			<div className="w-60 tl ph3">
				Team
			</div>
			<div className="w-40 tc">
				Results
			</div>
		</div>*/}
		{(teams || []).map((team, idx) => 
				<TableRow 
					key={idx}
					team={team}
					index={idx}
				/>
      )}
	</div>);
}

export default Table;